import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test140625 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 14/06/2025 Candidates</h3>
      <br />
      <br />



        <div><Link to='/conduct-nitchakarnt'>1. AAT 7759  CPO1.NITCHAKARN THAWORNKAN(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-sanphets'>2. AAT 7761  CPO.SANPHET SUKPRATHUEANG(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>3. AAT 7832  CPO1.SUPACHAI SITTIRUK(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-metapornc'>4. AAT 7833  MS.METAPORN CHIM-IM(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>5. AAT 7779  MS.KANOKPHON CHAIYAWONG(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-yanint'>6. AAT 7822  MS.YANIN TAIYANON(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>7. AAT 7923  MR.THOMAS MOENKEMEIER(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>8. ATT  7910  MR.NAPOL PITAYAPAT(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>9. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>10. AAT 7783  LT.NIRUN CHANTAWARO(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-thongchomphunutr'>11. AAT 7887  MS.THONGCHOMPHUNUT ROJVIBOONCHAI(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-natsawittau'>12. AAT 7887  MS.NATSAWITTA UNGPRAPAKORN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-tarah'>13. AAT 7887  MS.TARA ROSE HEBBLETHWAITE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>14. AAT 7972  CPO1.SUNYA LAEID(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-jamesrh'>15. AAT 8003  MR.JAMES RICKY HEBBLETHWAITE(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-natthapony'>16. AAT 8004  MR.NATTHAPON YATAN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-crystalmd'>17. AAT 8005  MS.CRYSTAL MARIE DABI(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>18. AAT 8006  MS.NUEA SUDRAK(WB)---Trying for 10KYU</Link></div>
        <br />





        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test140625;
